/**
 * Created by Nisarg on 7/18/2017.
 */
import React, {Component} from 'react';
import firebase from 'firebase';
import $ from 'jquery';
import _HauteFire from '../../Utils/HauteFire';
const HauteFire = new _HauteFire();

export default class AddCategory extends Component {
    constructor() {
        super();

        this.state = {categoryDetails: {}, fileCategory: {}, fileBanner: {}}
    }

    componentDidMount() {
        const params = this.props.match.params, _this = this;
        if (params) {
            const id = params.id;

            let categoryRef = firebase.database().ref("CategoryDetails/" + id);
            categoryRef.on('value', ((response) => {

                const categoryDetails = response.val();
                if (categoryDetails != null && !$.isEmptyObject(categoryDetails)) {
                    $("#txtCategoryName").val(categoryDetails.name);

                    const categoryPics = categoryDetails.categoryPics;
                    if (!$.isEmptyObject(categoryPics)) {
                        const categoryPicObj = categoryPics.categoryPicObj;
                        if (!$.isEmptyObject(categoryPicObj)) {
                            $("img#imgCategory").attr("src", categoryPicObj.url);
                        }

                        const bannerPicObj = categoryPics.bannerPicObj;
                        if (!$.isEmptyObject(bannerPicObj)) {
                            $("img#imgCategoryBanner").attr("src", bannerPicObj.url);
                        }
                    }

                    _this.setState({categoryDetails});
                }
                else {
                    $("#txtCategoryName").val("");
                    $("img#imgCategory").attr("src", "../../../../../img/vacation-kind2.jpg");
                    $("img#imgCategoryBanner").attr("src", "../../../../../img/romance-banner.jpg");

                    _this.setState({categoryDetails: {}, fileCategory: {}, fileBanner: {}});
                }
            }))
        }
        else {
            _this.setState({categoryDetails: {}, fileCategory: {}, fileBanner: {}});
        }
    }

    componentWillReceiveProps(nextProps) {
        const params = nextProps.match.params;
        if ($.isEmptyObject(params)) {
            $("#txtCategoryName").val("");
            $("img#imgCategory").attr("src", "../../../../../img/vacation-kind2.jpg");
            $("img#imgCategoryBanner").attr("src", "../../../../../img/romance-banner.jpg");
        }
        else {
            this.componentDidMount();
        }
    }

    changeCategoryImg(e) {
        let _file = e.currentTarget.files[0];
        if (_file) {
            let reader = new FileReader();
            reader.onload = (e) => {
                $("#imgCategory").show();
                $("#imgCategory").attr("src", e.target.result);
            };
            reader.readAsDataURL(_file);
            this.setState({fileCategory: _file});
        }
    }

    changeBannerImg(e) {
        let _file = e.currentTarget.files[0];
        if (_file) {
            let reader = new FileReader();
            reader.onload = (e) => {
                $("#imgCategoryBanner").show();
                $("#imgCategoryBanner").attr("src", e.target.result);
            };
            reader.readAsDataURL(_file);
            this.setState({fileBanner: _file});
        }
    }

    saveCategory() {
        $("#btnSaveCategory").attr("disabled", "disabled");
        $("#btnSaveCategory").html('<i class="fa fa-spinner fa-spin fa-fw"></i> Saving');

        let categoryDetails = this.state.categoryDetails;
        let id;
        if (typeof categoryDetails.id == typeof undefined) {
            id = categoryDetails.id = new Date().getTime();
        }
        else {
            id = categoryDetails.id;
        }

        if (!$.isEmptyObject(this.state.fileCategory) || !$.isEmptyObject(this.state.fileBanner)) {
            const _this = this;

            function* categoryGenerator() {
                var categoryPic = {}, bannerPic = {};
                if (!$.isEmptyObject(_this.state.fileCategory)) {
                    let categoryUrl = yield HauteFire.uploadFile(_this.state.fileCategory, "Categories/");
                    categoryPic.name = _this.state.fileCategory.name;
                    categoryPic.url = categoryUrl;
                }
                if (!$.isEmptyObject(_this.state.fileBanner)) {
                    let bannerUrl = yield HauteFire.uploadFile(_this.state.fileBanner, "Categories/");
                    bannerPic.name = _this.state.fileBanner.name;
                    bannerPic.url = bannerUrl;
                }
                return {categoryPicObj: categoryPic, bannerPicObj: bannerPic};
            }

            function categoryWrapper() {
                const gen = categoryGenerator();

                function handle(yielded) {
                    if (!yielded.done) {
                        yielded.value.then((url) => {
                            return handle(gen.next(url));
                        })
                    }
                    else {
                        let obj = yielded.value, categoryDetails = _this.state.categoryDetails;
                        if (!$.isEmptyObject(obj)) {
                            if ($.isEmptyObject(categoryDetails.categoryPics)) {
                                categoryDetails.categoryPics = obj;
                            }
                            else {
                                const categoryPics = obj.categoryPics;
                                if (!$.isEmptyObject(categoryPics)) {
                                    const categoryPicObj = categoryPics.categoryPicObj;
                                    if (!$.isEmptyObject(categoryPicObj)) {
                                        categoryDetails.categoryPics.categoryPicObj = categoryPicObj;
                                    }
                                    const bannerPicObj = categoryPics.bannerPicObj;
                                    if (!$.isEmptyObject(bannerPicObj)) {
                                        categoryDetails.categoryPics.bannerPicObj = bannerPicObj;
                                    }
                                }
                            }

                            HauteFire.addUpdate(id, categoryDetails, "CategoryDetails");
                            _this.setState({categoryDetails: {}, fileCategory: {}, fileBanner: {}});
                            $("#btnSaveCategory").removeAttr("disabled");
                            $("#btnSaveCategory").html('<i class="fa fa-floppy-o" aria-hidden="true"></i> SAVE');
                        }
                    }
                }

                return handle(gen.next());
            }

            categoryWrapper();
        }
        else {
            HauteFire.addUpdate(id, categoryDetails, "CategoryDetails");

            this.setState({categoryDetails: {}, fileCategory: {}, fileBanner: {}});
            $("#btnSaveCategory").removeAttr("disabled");
            $("#btnSaveCategory").html('<i class="fa fa-floppy-o" aria-hidden="true"></i> SAVE');
        }

        $("#txtCategoryName").val("");
        $("#fileCategory").val("");
        $("#fileBanner").val("");
    }

    render() {
        return (
            <div className="animated fadeIn">
                <div className="row">

                    <div className="col-md-12 mb-4">
                        <button id="btnSaveCategory" type="button" className="btn btn-primary float-right"
                                onClick={this.saveCategory.bind(this)}
                        >
                            <i className="fa fa-floppy-o" aria-hidden="true"></i> SAVE
                        </button>
                    </div>

                    <div className="col-lg-12">
                        <div className="card">
                            <div className="card-header">
                                <i className="fa fa-edit"></i>Add Category
                            </div>
                            <div className="card-block">
                                <form className="form-2orizontal">

                                    <div className="form-group">
                                        <label className="form-control-label" htmlFor="txtCategoryName">Name</label>
                                        <div className="controls">
                                            <div className="input-prepend input-group">
                                                <input id="txtCategoryName" className="form-control" size="16"
                                                       type="text" onInput={(e) => {
                                                        let categoryDetails = this.state.categoryDetails;
                                                        let name = e.currentTarget.value.trim();
                                                        if(name != "") {
                                                            categoryDetails.name = name;
                                                            this.setState({categoryDetails});
                                                        }
                                                       }}/>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <label className="col-md-2 form-control-label"
                                               htmlFor="fileBanner">Category</label>
                                        <div className="col-md-4">
                                            <input type="file" id="fileCategory"
                                                   accept="image/*" onChange={(e) => this.changeCategoryImg(e)}/>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-md-2 form-control-label" htmlFor="fileBanner">Banner
                                            Picture</label>
                                        <div className="col-md-4">
                                            <input type="file" id="fileBanner" name="fileBanner" accept="image/*"
                                                   onChange={(e) => this.changeBannerImg(e)}/>
                                        </div>
                                    </div>

                                    <div className="row">

                                        <div className="col-md-3">
                                            <div className="imgcard-group mb-0">
                                                <div className="imgcard imgcard-cascade wider">
                                                    <div className="view overlay hm-white-slight">
                                                        <img id="imgCategory"
                                                             src="../../../../../img/vacation-kind2.jpg"
                                                             alt="Island Logo" className="img-fluid"
                                                        />
                                                        <a>
                                                            <div className="mask waves-effect waves-light"></div>
                                                        </a>
                                                    </div>
                                                    <div className="imgcard-block-banner text-center">
                                                        <h4 className="imgcard-title"><strong
                                                            style={{fontFamily:"Fjalla One"}}>Category</strong>
                                                        </h4>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-8">
                                            <div className="imgcard-group mb-0">
                                                <div className="imgcard imgcard-cascade wider">
                                                    <div className="view overlay hm-white-slight">
                                                        <img id="imgCategoryBanner"
                                                             src="../../../../../img/romance-banner.jpg"
                                                             alt="Category Banner" className="img-fluid"
                                                        />
                                                        <a>
                                                            <div className="mask waves-effect waves-light"></div>
                                                        </a>
                                                    </div>
                                                    <div className="imgcard-block-banner text-center">
                                                        <h4 className="imgcard-title"><strong
                                                            style={{fontFamily:"Fjalla One"}}>Banner</strong>
                                                        </h4>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/IslandManagement/AddCategory/AddCategory.js